import axios from "axios"
import {backendHosts} from './apiConfig'

const axiosInstance = axios.create({
  baseURL: backendHosts.CRM || "https://fallback-url.com",
  headers: {
    "Accept": "*/*",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "accept": "application/json",
    "Authorization": localStorage.getItem('token') || undefined,
  }
})

export const updateToken = () => {
  axiosInstance.defaults.headers.Authorization = localStorage.getItem('token') || undefined
}

export const httpRequest = async ({
  method = "post",
  endPoint,
  params = {},
  requestBody = {},
  headers   //dev-trupti on 11-12-2024 
}) => {

  try {

    const response = await axiosInstance({
      method,
      url: endPoint,
      params,
      data: requestBody,
      headers:headers    //dev-trupti on 11-12-2024 
    })

    return response.data
  } 

  catch (error) {
    
    console.error("Error in API call", error)
    throw error.response.data
  }
}

// console.log("backendHosts:", backendHosts);